/* cs-behavior-monitor (2026-09-17 v3) — 店面「行为监控 + 扒 Banner 自动封禁」(防同行)
   记录人用浏览器时的前兆动作,连同设备指纹 dfp(与 support-widget.js deviceSig 同算法 → 可跨系统归为同一人)+ 页面路径,批量 beacon 到 ERP。
   采集:右键点图 / 拖图 / 复制大段文字 / Ctrl+U / Ctrl+S / F12·Ctrl+Shift+I/J/C / PrintScreen / DevTools 尺寸启发式。
   自动封禁(v3 规则,用户定):
     · 图片先分类 —— banner(首页/合集页的 hero 大图、轮播、营销区块)/ product(产品卡、产品图)/ other(logo、分类导航小图、评论图、聊天插件 → 忽略)
     · 扒 banner ≥ thresholdBanner(默认 1 张)→ 当场换"unavailable"页 + 上报指纹入封禁名单。真顾客不会存 Banner,存的都是来抄店的。
     · 产品图只记录、不封(顾客存产品图很正常)。后台可选开产品图规则 A/B(默认 0=关)。
     · 之后每次加载先查指纹,封禁的直接拦(换 VPN/清 cookie 无效,换浏览器才变)。阈值由 /guard 下发可调。
   分类靠本主题(Dawn + 自定义 cs-* 层)的容器 class;顺序 = 排除 → banner → product → other,banner 还要求图够大(小图标不算)。
   说明:情报非证据;走 JSON 接口/curl 的爬虫测不到。爬虫 UA 一律跳过。非阻塞(defer),任何失败静默 fail-open。 */
(function () {
  try {
    var UA = navigator.userAgent || "";
    if (/googlebot|adsbot-google|mediapartners-google|apis-google|feedfetcher-google|google-inspectiontool|storebot-google|googleother|google-extended|chrome-lighthouse|bingbot|bingpreview|msnbot|adidxbot|duckduckbot|duckduckgo|yahoo|slurp|yandex|baiduspider|sogou|360spider|seznambot|petalbot|coccocbot|mj12bot|dotbot|naver|yeti|exabot|ia_archiver|archive\.org_bot|applebot|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterest|whatsapp|telegrambot|slackbot|discordbot|redditbot|skypeuripreview|embedly|vkshare|bytespider|amazonbot|gptbot|oai-searchbot|chatgpt-user|claudebot|claude-web|anthropic-ai|perplexitybot|perplexity-user|cohere-ai|ccbot|youbot|semrushbot|ahrefsbot|crawler|crawl|spider/i.test(UA)) return;

    var BASE = "https://erp.chinasquad.com/api/pub/behavior";
    var ENDPOINT = BASE + "/log";

    // —— 封页(与 geo-guard 同款"店铺不可用"页,不给任何提示)——
    function deny() {
      try { window.stop && window.stop(); } catch (e) {}
      try {
        document.documentElement.innerHTML = '<head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="robots" content="noindex"><title>Sorry, this shop is currently unavailable.</title></head><body style="margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;background:#fff;color:#454545;font-family:-apple-system,BlinkMacSystemFont,Roboto,Helvetica,Arial,sans-serif;text-align:center;padding:24px"><h1 style="font-size:24px;font-weight:400;line-height:1.4">Sorry, this shop is currently unavailable.</h1></body>';
      } catch (e) {}
    }

    // —— 设备指纹:与 support-widget.js 的 deviceSig() 严格同算法(FNV-1a + djb2 双哈希 → 16 hex)——
    var _sig = null;
    function deviceSig() {
      if (_sig) return _sig;
      var tz = "", off = 0;
      try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (e) {}
      try { off = new Date().getTimezoneOffset(); } catch (e) {}
      var fp = "";
      try {
        var b = [navigator.userAgent || "", navigator.language || "", (navigator.languages || []).join(","),
          (screen.width + "x" + screen.height + "x" + (screen.colorDepth || "")), (window.devicePixelRatio || ""),
          (navigator.hardwareConcurrency || ""), (navigator.deviceMemory || ""), (navigator.platform || ""),
          (navigator.maxTouchPoints || ""), tz, off];
        try { var c = document.createElement("canvas"); c.width = 200; c.height = 40; var g = c.getContext("2d"); g.textBaseline = "top"; g.font = "14px Arial"; g.fillStyle = "#069"; g.fillRect(2, 2, 120, 20); g.fillStyle = "#a33"; g.fillText("cs-fp-Ag99", 4, 4); b.push(c.toDataURL()); } catch (e) {}
        try { var gl = document.createElement("canvas").getContext("webgl"); if (gl) { var dg = gl.getExtension("WEBGL_debug_renderer_info"); if (dg) { b.push(gl.getParameter(dg.UNMASKED_VENDOR_WEBGL) || ""); b.push(gl.getParameter(dg.UNMASKED_RENDERER_WEBGL) || ""); } } } catch (e) {}
        var str = b.join("|"), h1 = (2166136261 >>> 0);
        for (var i = 0; i < str.length; i++) { h1 ^= str.charCodeAt(i); h1 = (h1 + ((h1 << 1) + (h1 << 4) + (h1 << 7) + (h1 << 8) + (h1 << 24))) >>> 0; }
        var h2 = 5381; for (var k = 0; k < str.length; k++) { h2 = (((h2 << 5) + h2) + str.charCodeAt(k)) >>> 0; }
        fp = ("0000000" + h1.toString(16)).slice(-8) + ("0000000" + h2.toString(16)).slice(-8);
      } catch (e) {}
      _sig = { dfp: fp, tz: tz, tzoff: off };
      return _sig;
    }
    var DFP = deviceSig().dfp;

    // —— 0) 店主/团队豁免 + 解封链接 ——
    // 打开一次 https://chinasquad.com/?cs_pass=<后门密码>(与 geo-guard 同一个密码),或该设备已通过 geo-guard 后门(cs_geo_pass)
    // → 清掉本地封禁标记,且这台设备以后永不被自动封(自己测试/团队看店不会把自己锁在外面)。
    var IMMUNE = false;
    try {
      if (new URLSearchParams(location.search).get("cs_pass") === "chuhao319") { try { localStorage.setItem("cs_ab_immune", "1"); } catch (e) {} }
      if (localStorage.getItem("cs_ab_immune") === "1" || localStorage.getItem("cs_geo_pass") === "1" || /(?:^|;\s*)cs_geo_pass=1/.test(document.cookie)) IMMUNE = true;
      if (IMMUNE) { try { localStorage.removeItem("cs_autoban"); } catch (e) {} }
    } catch (e) {}

    // —— 1) 本地已封标记(秒拦,不等网络)——
    try { if (!IMMUNE && localStorage.getItem("cs_autoban") === "1") { deny(); return; } } catch (e) {}

    // —— 2) 手工指纹黑名单(写死;改数组重新上传本文件)——
    var BLOCKED_FP = ["1f4a396a6b980312"];
    if (!IMMUNE && DFP && BLOCKED_FP.indexOf(DFP) >= 0) { try { localStorage.setItem("cs_autoban", "1"); } catch (e) {} deny(); return; }

    // —— 3) 服务端封禁名单 + 阈值(每次加载查一次;查不到/失败 → 放行 fail-open)——
    var AB = { enabled: true, banner: 1, total: 0, list: 0 };   // total/list = 产品图规则,0=关
    var banned = false;
    function banLocal() { banned = true; try { localStorage.setItem("cs_autoban", "1"); } catch (e) {} }
    try {
      fetch(BASE + "/blocked?dfp=" + encodeURIComponent(DFP), { credentials: "omit", cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.cfg) {
            AB.enabled = d.cfg.enabled !== false;
            AB.banner = Math.max(1, Number(d.cfg.banner) || 1);
            AB.total = Number(d.cfg.total) || 0;
            AB.list = Number(d.cfg.list) || 0;
          }
          if (d && d.blocked === true && !IMMUNE) { banLocal(); deny(); }
        }).catch(function () {});
    } catch (e) {}

    // —— 事件队列 + 批量上报 ——
    var queue = [], sent = 0, SESSION_CAP = 200, seen = {}, timer = null;
    function push(type, detail) {
      if (sent >= SESSION_CAP) return;
      detail = (detail == null ? "" : String(detail)).slice(0, 300);
      var key = type + "|" + detail, now = +new Date();
      if (seen[key] && now - seen[key] < 3000) return; // 同事件 3s 内去重,防刷
      seen[key] = now;
      queue.push({ type: type, detail: detail });
      if (!timer) timer = setTimeout(flush, 1500);
    }
    function flush() {
      timer = null;
      if (!queue.length) return;
      var batch = queue.splice(0, 50); sent += batch.length;
      var d = deviceSig();
      var body = JSON.stringify({
        dfp: d.dfp, tz: d.tz, tzoff: d.tzoff, lang: navigator.language || "",
        path: (location.pathname || "").slice(0, 200), events: batch,
      });
      try {
        // text/plain = 简单请求,不触发跨域预检;后端已按 text 解析
        if (navigator.sendBeacon) { navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain;charset=UTF-8" })); }
        else { fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body, keepalive: true, credentials: "omit", mode: "no-cors" }); }
      } catch (e) {}
    }
    try {
      window.addEventListener("pagehide", flush);
      document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") flush(); });
    } catch (e) {}

    // —— 图片分类(本主题 = Dawn + 自定义 cs-* 层;顺序:排除 → banner → product → other)——
    // 排除:页眉/页脚/logo、分类导航小图(cs-card 网格、cs-iconnav 图标、cs-l3-links)、Judge.me 评论图、聊天插件(cb-*)、社交/微信弹层
    var SEL_EXCLUDE = 'header, .header, footer, .footer, .cs-cardgrid, .cs-card, .cs-iconnav, .cs-l3-links, .cs-list, .cs-wx-pop, .list-social, .announcement-bar, [class*="jdgm"], [class*="cb-"]';
    // banner:轮播/hero 大图/营销区块(自定义 cs-l3-hero、cs-women-tiles;Dawn 的 slideshow/banner/collection-hero/image-with-text/multicolumn/rich-text)
    var SEL_BANNER  = '.slideshow, .slideshow__slide, .cs-l3-hero, .cs-women-tiles, .cs-women-tile, .banner, .image-banner, .collection-hero, .image-with-text, .multicolumn, .rich-text';
    // product:产品卡/产品图(Dawn card--product、自定义 ccsg 网格、任何指向 /products/ 的链接)
    var SEL_PRODUCT = '.card--product, .card__media, .card-wrapper, .product__media, .product-media, product-card, [data-product-id], .ccsg-card, .ccsg-grid, a[href*="/products/"]';
    function imgKind(img) {
      try {
        if (img.closest(SEL_EXCLUDE)) return "other";
        if (img.closest(SEL_BANNER)) return (img.clientWidth >= 250 || img.naturalWidth >= 600) ? "banner" : "other"; // 小图标不算 banner
        if (img.closest(SEL_PRODUCT)) return "product";
      } catch (e) {}
      return "other";
    }

    // —— 扒图计数 + 自动封禁 ——
    var IS_LIST = /(^|\/)(collections|search)(\/|$)/.test(location.pathname || "");
    var grabbed = {}, grabCount = 0, listGrabs = 0, bannerGrabs = 0;
    function autoBan(reason) {
      if (banned || IMMUNE) return;   // 店主/团队豁免设备永不自动封
      banLocal();
      queue.push({ type: "auto-ban", detail: reason + " banner=" + bannerGrabs + " grabs=" + grabCount + " list=" + listGrabs + " page=" + (location.pathname || "").slice(0, 80) });
      flush();   // sendBeacon 已发出,换页不影响
      deny();
    }
    function onGrab(img, evType) {
      var src = (img.currentSrc || img.src || "").slice(0, 200);
      var kind = imgKind(img);
      if (kind === "other") return;                       // logo/导航小图/评论图:不记不封
      if (kind === "banner") {                            // Banner:记 + 扒 ≥N 张当场封
        push("banner-grab", src);
        bannerGrabs++;
        if (!banned && AB.enabled && bannerGrabs >= AB.banner) autoBan("banner>=" + AB.banner);
        return;
      }
      push(evType, src);                                  // product:只记录,不封
      var k = src.split("?")[0]; if (k && !grabbed[k]) { grabbed[k] = 1; grabCount++; }
      if (IS_LIST) listGrabs++;
      if (!banned && AB.enabled) {                        // 产品图规则默认关(total/list=0);后台设 >0 才生效
        if (AB.total > 0 && grabCount >= AB.total) autoBan("A:total>=" + AB.total);
        else if (AB.list > 0 && listGrabs >= AB.list) autoBan("B:list>=" + AB.list);
      }
    }

    // —— 监听:右键点图 / 拖图 ——
    document.addEventListener("contextmenu", function (ev) { var t = ev.target; if (t && t.tagName === "IMG") onGrab(t, "img-contextmenu"); }, true);
    document.addEventListener("dragstart", function (ev) { var t = ev.target; if (t && t.tagName === "IMG") onGrab(t, "img-drag"); }, true);

    // —— 复制大段文字(≥30 字,像在抄文案)——
    document.addEventListener("copy", function () {
      try { var s = (window.getSelection && String(window.getSelection())) || ""; if (s.length >= 30) push("selection-copy", "len=" + s.length); } catch (e) {}
    }, true);

    // —— 键盘快捷键 ——
    document.addEventListener("keydown", function (ev) {
      var k = (ev.key || "").toLowerCase(), ctrl = ev.ctrlKey || ev.metaKey;
      if (k === "f12") push("key-f12", "");
      else if (ctrl && ev.shiftKey && (k === "i" || k === "j" || k === "c")) push("key-devtools", "ctrl+shift+" + k);
      else if (ctrl && !ev.shiftKey && k === "u") push("key-viewsource", "");
      else if (ctrl && !ev.shiftKey && k === "s") push("key-savepage", "");
    }, true);
    document.addEventListener("keyup", function (ev) {
      if ((ev.key || "") === "PrintScreen" || ev.keyCode === 44) push("printscreen", "");
    }, true);

    // —— DevTools 开启启发式(窗口内外尺寸差;误报多,只当弱信号)——
    var dtOpen = false;
    function checkDevtools() {
      try {
        var thr = 160;
        var open = (window.outerWidth - window.innerWidth > thr) || (window.outerHeight - window.innerHeight > thr);
        if (open && !dtOpen) { dtOpen = true; push("devtools-open", "size-delta"); }
        else if (!open && dtOpen) { dtOpen = false; }
      } catch (e) {}
    }
    try { setInterval(checkDevtools, 2500); } catch (e) {}
  } catch (e) { /* 静默,绝不影响店面 */ }
})();
